import React from 'react';
import Box from '@mui/material/Box';

interface LayoutThemeProps {
  type: 'logo' | 'kedma' | 'messengers';
  children?: React.ReactNode;
}

// פונקציה משותפת לעיצוב הכותרות
const renderHeader = (title: string, icon?: React.ReactNode, iconColor?: string, fontSize = 22) => (
  <Box
    sx={{
      mt: 2,
      mb: 2,
      px: 2,
      py: 1,
      background: 'none',
      textAlign: 'center',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}
  >
    <Box sx={{ position: 'relative', display: 'inline-block', mb: 1 }}>
      {icon && (
        <Box
          sx={{
            position: 'absolute',
            top: 1,
            right: 48,
            zIndex: 1
          }}
        >
          {icon}
        </Box>
      )}
      <Box sx={{ color: 'white', fontWeight: 700, fontSize: fontSize }}>{title}</Box>
    </Box>
    <Box
      sx={{
        height: 2,
        width: '80%',
        mx: 'auto',
        backgroundColor: iconColor || '#FFA726',
        borderRadius: 1
      }}
    />
  </Box>
);

const LayoutTheme: React.FC<LayoutThemeProps> = ({ type, children }) => {
  if (type === 'logo') {
    return (
      <Box sx={{ textAlign: 'center', mb: 2 }}>
        <Box sx={{ fontWeight: 700, fontSize: 20, mb: 0.5 }}>
          <span style={{ color: '#FFA726' }}>chabad</span>
          <span style={{ color: '#fff' }}>israel.co.il</span>
        </Box>
        <Box
          sx={{
            height: 2,
            width: '70%',
            mx: 'auto',
            backgroundColor: '#FFA726',
            borderRadius: 1,
            mb: 1
          }}
        />
        {children}
      </Box>
    );
  }

  if (type === 'kedma') {
    return (
      <>
        {renderHeader('קדמה', undefined, '#F68B28')}
        {children}
      </>
    );
  }

  if (type === 'messengers') {
    return (
      <>
        {renderHeader('פרויקטים מיוחדים', undefined, '#FFA726', 18)}
        {children}
      </>
    );
  }

  return null;
};

export default LayoutTheme;
